import { Logger } from "../core/Logger.js";

/**
 * Provides the ability to trigger vibration patterns on devices that support it,
 * such as mobile devices.
 */
export class Haptics {
  /**
   * Checks if the Vibration API is supported by the browser.
   */
  static isSupported() {
    if (typeof navigator == 'undefined') {
      return false;
    }
    return 'vibrate' in navigator;
  }

  /**
   * Defines the vibration pattern. It can be a single duration in milliseconds or an array of durations
   * where each number represents a vibration duration followed by a pause.
   */
  static vibrate(pattern) {
    if (!Haptics.isSupported()) {
      Logger.warn('Vibration API is not supported on this device.');
      return;
    }

    if (Array.isArray(pattern)) {
      navigator.vibrate(pattern);
    } else if (typeof pattern === 'number') {
      navigator.vibrate(pattern);
    } else {
      Logger.error('Pattern must be a number or an array of numbers.');
    }
  }

  /**
   * Stops any ongoing vibration.
   */
  static cancel() {
    if (Haptics.isSupported()) {
      navigator.vibrate(0);
    }
  }
}
